<template>
	<div>
		<div class="manage-date-select">
      <label>充值状态</label>
      <span>
        <el-select v-model="status" filterable placeholder="请选择描述" style="width: 200px;">
          <el-option
            v-for="item in optionList.status"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </span>
			<!-- <label style="margin-left: 15px;">更新时间</label>
			<span>
				<el-date-picker
        style="width: 400px;"
            class="elpic"
			      v-model="value7"
			      type="datetimerange"
			      align="right"
			      placeholder="选择日期范围"
			      @change="setTime"
			      :picker-options="pickerOptions2">
			    </el-date-picker>
			</span> -->


      <div style="margin: 15px 0;">
        <span class="shelves-filter-btn-default shelves-filter mar-left-10" @click="timeInit">查询</span>
         <span style="border: 1px solid #ccc;" class="shelves-filter-btn-default mar-left-10" @click="reset">重置</span>

       </div>
		</div>
		<div style="margin-top: 30px;">
			<el-table
		    :data="tableData"
		    border
		    empty-text
		    style="width: 100%;text-align: center">
		    <el-table-column
        width="80"
		      prop="id"
		      label="申请ID"
          align="center">
		    </el-table-column>
		    <el-table-column
		      label="充值金额"
		      width="120"
          align="center">
		      <template slot-scope="scope">
		      		<div>{{scope.row.money}}</div>
		      </template>
		    </el-table-column>
        <el-table-column label="凭证" align="center" width="120">
          <template slot-scope="scope">
            <el-image
              style="width: 60px; height: 60px"
              :src="scope.row.pictureUrl"
              :preview-src-list="[scope.row.pictureUrl]">
            </el-image>
            <!-- <el-popover trigger="hover" placement="top" popper-class="table-popover">
              <div class="popover-center">
                <img  style="width: 120px;" :src="scope.row.pictureUrl"/>
              </div>
              <div slot="reference" class="thumb-img">
                <img style="width: 60px;" :src="scope.row.pictureUrl"/>
              </div>
            </el-popover> -->
          </template>
        </el-table-column>
        <el-table-column
		      label="充值状态"
		      width="120"
          align="center">
		      <template slot-scope="scope">
		      		<div style="color: #67C23A" v-if="scope.row.status == 300">已入账</div>
              <div style="color: #E6A23C" v-else-if="scope.row.status == 100">待处理</div>
              <div style="color: #F56C6C" v-else-if="scope.row.status == 200">已拒绝</div>
		      </template>
		    </el-table-column>
        <el-table-column
		      label="拒绝理由"
		      width="160"
          align="center">
		      <template slot-scope="scope">
              <div v-if="scope.row.status == 200 && scope.row.refusedReason">{{scope.row.refusedReason}}</div>
		      </template>
		    </el-table-column>
        <el-table-column
		      prop="createTime"
		      label="创建时间"
          align="center">
		    </el-table-column>
        <el-table-column
		      prop="updateTime"
		      label="更新时间"
          align="center">
		    </el-table-column>
		  </el-table>
		</div>
		<div class="block">
			<el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page.sync="pageNum" :total="total" :page-size="pageSize"></el-pagination>
		</div>

	</div>
</template>
<script>
	import store from '../store/index.js'
  import axios from 'axios'
  import {queryChargeApplyMall, excelNewExcel} from '../config/interface.js'
	import {toast} from '../util/tool.js'
  import {fetch} from '../config/fetch.js'

	export default{
		data(){

			return {
				pickerOptions2: {
		          	shortcuts: [{
			            text: '最近一周',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
			              picker.$emit('pick', [start, end]);
			            }
		          	}, {
			            text: '最近一个月',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
			              picker.$emit('pick', [start, end]);
			            }
		          	}, {
			            text: '最近三个月',
			            onClick(picker) {
			              const end = new Date();
			              const start = new Date();
			              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
			              picker.$emit('pick', [start, end]);
			            }
		          	}]
		        },
		        value7: '',
				userId: store.state.userId,
				walletMoney: '',
				endTime: '',//结束时间
				startTime: '',
				tableData: [],
				pageSize: 10,
				pageNum: 1,
				total: 0,
        loading:false,
        orderSn: null,
        status: null,
        optionList: {
          status: [
            {
              id: null,
              name: '全部',
            },
            {
              id: 100,
              name: '待处理',
            },
            {
              id: 300,
              name: '已入账',
            },
            {
              id: 200,
              name: '已拒绝',
            }
          ]
        },
        appId: 0,

			}
		},
		mounted(){
			this.init();
		},
		methods: {

			init(){
			  if(this.endTime == ''){
          let timeDefaultShow = new Date();
		    	timeDefaultShow.setTime(timeDefaultShow.getTime()+24*60*60*1000);
	 			  let year = timeDefaultShow.getFullYear();
          let month = timeDefaultShow.getMonth() + 1;
          let strDate = timeDefaultShow.getDate();
          if (month >= 1 && month <= 9) {
              month = "0" + month;
          }
          if (strDate >= 0 && strDate <= 9) {
              strDate = "0" + strDate;
          }
          let seperator1 = '-';
          let nextDate = year + seperator1 + month + seperator1 + strDate;
			    this.endTime = nextDate + ' 00:00:00'
        }
				var data = {
					endTime: this.endTime,
					startTime: this.startTime,
					userId: this.userId,
					pageSize: this.pageSize,
          pageNum: this.pageNum,
          status: this.status,
          appId: this.$store.state.appId,
				};
				var url = queryChargeApplyMall;
				fetch(url, data)
				.then(res => {
					var list = res.data.result;
           list.forEach((item, index) => {
              item.money = item.money / 100;
              item.createTime = item.createTime.toString().substr(0, 19);
              item.updateTime = item.updateTime.toString().substr(0, 19);
            });
            this.total = res.data.count;
					this.tableData = list;
        });
			},

			timeInit(){
				this.total = 0;
				this.init();
      },
      reset(){
        this.endTime = null
				this.startTime = null
        this.pageNum = 1;
        this.status = null;
        this.init();
      },
			setTime(val){
        console.log(val);
				this.startTime = val.substring(0, 19);
				this.endTime = val.substring(22, 42);
			},
			handleCurrentChange(val){
				    this.pageNum = val;
		        this.init();
			},
			download(){
				if(this.startTime == ''||this.endTime == ''){
					var str = "请先选择时间";
	                toast(str, 2, false);
	                return;
				}
				const data = {
					endTime: this.endTime,
					startTime: this.startTime,
					userId: this.userId
				};

				const url = walletDownload;

				fetch(url, data)
				.then(res => {
					console.log(res);
				})
			}
		}
	}
</script>
<style scoped>
  .typered{
    color: red;
  }
  .el-button{
    margin-right: 14px;
    margin-left: 0;
    padding: 0;
    border-radius: 0;
  }
  .elpic{
    width: 210px;
  }
</style>



// WEBPACK FOOTER //
// Recharge.vue?2e9cc54b